import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, GLMKiloFlow, GLMKiloFlowCreate } from 'types';
import { client } from 'utils/api-client';

export default function useCreateGLMKiloFlow(): UseMutationResult<
  AxiosResponse<GLMKiloFlow>,
  AxiosError<ErrorMessage>,
  GLMKiloFlowCreate
> {
  const queryClient = useQueryClient();

  const createGLMKiloFlow = (flow: GLMKiloFlowCreate): Promise<AxiosResponse<GLMKiloFlow>> => {
    return client.post('glm-kilo-flows/', flow);
  };

  return useMutation(createGLMKiloFlow, {
    onSuccess: () => {
      queryClient.invalidateQueries('glm-kilo-flows');
    },
  });
}
